import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { of, switchMap } from 'rxjs';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const authService = inject(AuthService);

    // No uses solo authenticated$: con ReplaySubject sin emisiones previas, take(1) nunca completaba.
    // check() consulta la sesión (Amplify) y actualiza el estado.
    return authService.check().pipe(
        switchMap(authenticated => {
            if (!authenticated) {
                const redirectURL =
                    state.url === '/sign-out'
                        ? ''
                        : `redirectURL=${encodeURIComponent(state.url)}`;
                const urlTree = router.parseUrl(`home/sign-in?${redirectURL}`);
                return of(urlTree);
            }
            return of(true);
        })
    );
};
